import { ref } from 'vue';
export function useMain() {
    let initeText = '<div></div>';
    for (let i = 0; i < 40; i++) {
        initeText += '<div></div>';
    }
    // 入力エリアのテキスト
    const targetText = ref(initeText);
    // 自動修正チェツクの数
    const fixCounter = ref(0);
    const updateFixCounter = (count) => {
        fixCounter.value = count;
    };
    const resetFixCounter = () => {
        fixCounter.value = 0;
    };
    return {
        targetText,
        fixCounter,
        updateFixCounter,
        resetFixCounter
    };
}
